import { FC } from "react";
import cn from "classnames";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { IconProp } from "@fortawesome/fontawesome-svg-core";
import { useDropdownContext } from "../dropdown-context";

export interface DropdownIconProps {
  icon?: IconProp;
  className?: string;
}

const DropdownIcon: FC<DropdownIconProps> = ({ icon, children, ...rest }) => {
  const { getBlocksWith, getIconProps } = useDropdownContext();

  if (!getIconProps) {
    throw new Error(
      "Dropdown.Icon component requires getIconProps to be defined",
    );
  }
  return (
    <span {...getIconProps({ ...rest })}>
      {icon && (
        <FontAwesomeIcon
          icon={icon}
          className={cn(getBlocksWith("__icon-svg"))}
        />
      )}
      {children}
    </span>
  );
};

export default DropdownIcon;
